module.exports = __webpack_public_path__ + "img/noData2.cfd818d8.png";